export default "__VITE_ASSET__BQI6XGAF__"